import { z } from 'zod';

// ── PlanFeaturesSchema (saas-monetization-plans v2 — WU-A) ──────────────────
//
// Provider-neutral, backend↔frontend typed feature blob stored as JSON on
// `Plan.features` and gated by `PlanFeatureGuard` (design §2.2/§5). A single
// validated schema — not one boolean column per feature — so new flags can
// append here without a migration. `supportTier` is graduated
// (email < priority < dedicated), not boolean, per the client pricing PDF.
//
// Callers reading a possibly-null/malformed DB blob MUST treat a failed
// parse as "no features" (fail-safe, never throw at gate time) — this
// schema itself is strict (rejects null/non-object input) so that decision
// stays explicit at the call site (see Plan entity `features` getter).

export const PlanFeaturesSchema = z.object({
  multiLocation: z.boolean().default(false),
  sms: z.boolean().default(false),
  damageReports: z.boolean().default(false),
  advancedAnalytics: z.boolean().default(false),
  customBranding: z.boolean().default(false),
  whiteLabel: z.boolean().default(false),
  api: z.boolean().default(false),
  supportTier: z.enum(['email', 'priority', 'dedicated']).default('email'),
});

export type PlanFeatures = z.infer<typeof PlanFeaturesSchema>;

/** Rank used to compare graduated support tiers (design §5, feature-gate check). */
export const SUPPORT_TIER_RANK: Record<PlanFeatures['supportTier'], number> = {
  email: 0,
  priority: 1,
  dedicated: 2,
};
